exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__previewBox___2r_MF{height:641px;overflow:scroll;border:1px solid rgba(0,0,0,.2)}", "", {"version":3,"sources":["/./containers/newsLetter/style.css"],"names":[],"mappings":"AAAA,2BACE,aAAc,AACd,gBAAiB,AACjB,+BAAqC,CACtC","file":"style.css","sourcesContent":[".previewBox {\n  height: 641px;\n  overflow: scroll;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"previewBox": "style__previewBox___2r_MF"
};


//////////////////
// WEBPACK FOOTER
// /data/www/SGDBackend-Nex2/~/css-loader?modules&sourceMap&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!/data/www/SGDBackend-Nex2/~/postcss-loader!./containers/newsLetter/style.css
// module id = 562
// module chunks = 0